import dayjs from 'dayjs/esm/index.js'

export const updateYearQuery = (year: number) => {
  const route = useRoute()
  const router = useRouter()

  if (!year) return
  if (year === dayjs().year()) {
    const query = Object.assign({}, route?.query)
    delete query.year
    router.replace({ query })
  } else {
    router.push({
      query: { ...route?.query, year: String(year) }
    })
  }
}
